// extracted by mini-css-extract-plugin
export default {"page":"NotAvailable_page__+SeXh","logo":"NotAvailable_logo__kxqp+"};